import { cn } from "@/lib/utils";
import * as React from "react";

/**
 * Monica's design system doesn't ship a `<textarea>` primitive, so this
 * mirrors `Input`'s visual language (border/focus/disabled states) for the
 * support message field. Kept local to `routes/support` per task scope.
 */
export const SupportTextarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<"textarea">>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "flex min-h-[160px] w-full rounded-2xl border border-borderLight bg-transparent px-4 py-3 text-xs transition-colors placeholder:text-subtle focus-visible:border-brandTangerine focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-brandTangerine aria-invalid:border-redDark hover:border-borderDark hover:disabled:border-borderLight disabled:cursor-not-allowed disabled:bg-backgroundLight disabled:text-textSubtle resize-y",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
SupportTextarea.displayName = "SupportTextarea";
